import { render, staticRenderFns } from "./FCellList.vue?vue&type=template&id=2a8962ee&"
import script from "./FCellList.vue?vue&type=script&lang=ts&"
export * from "./FCellList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports